import { mapKeys, isFunction } from 'lodash';
import { getURLSearchParameters, redirect } from '@core/lib/utils/location';

/**
 * @param {Response} response
 * @returns {Response}
 */
export async function redirectInterceptor(response) {
  // Angular returns headers as a function, and axios returns as an Object
  const rawHeaders = isFunction(response.headers) ? response.headers() : response.headers;
  const responseHeaders = mapKeys(rawHeaders, (_, key) => key.toLowerCase());
  const locationHeader = responseHeaders['x-location'];

  // Hotfix: skip redirect with x-location when redirectUrl param is present
  // It's a FE workaround cause BE shouldn't always send it
  // An issue for BE will be raised
  const searchParams = getURLSearchParameters();
  const redirectUrl = searchParams.has('redirectUrl');

  if (locationHeader && !redirectUrl) {
    redirect(locationHeader);
    return Promise.reject(locationHeader);
  }

  return response;
}

export default redirectInterceptor;
